import type * as React from "react";

type Props = {
    rate?: number;
    uncertainty?: number;
    unit: string;
};

export const RateWithUncertaintyCell: React.FC<Props> = ({
    rate,
    uncertainty,
    unit,
}) => {
    if (rate == null) {
        return "-";
    }

    return (
        <div className="whitespace-nowrap">
            {rate.toFixed(2)}{" "}
            {uncertainty != null && <span>± {uncertainty.toFixed(2)} </span>}
            {unit}
        </div>
    );
};
